import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './page/home/home.component';
import { ProjectComponent } from './page/project/project.component';
import { OurServiceComponent } from './page/our-service/our-service.component';
import { AboutUsComponent } from './page/about-us/about-us.component';
import { FacilitiesComponent } from './page/facilities/facilities.component';
import { ContactUsComponent } from './page/contact-us/contact-us.component';
import { CareerComponent } from './page/career/career.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'work', component: ProjectComponent },
  { path: 'service', component: OurServiceComponent },
  { path: 'about', component: AboutUsComponent },
  { path: 'facilities', component: FacilitiesComponent },
  { path: 'contact', component: ContactUsComponent },
  { path: 'career', component: CareerComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
